import { useCallback, useEffect, useState } from "react";
import { api } from "@/lib/api";

export const notifyAlertsChanged = () => window.dispatchEvent(new Event("alerts:changed"));

const setBadge = (n) => {
  try { if (n > 0) navigator.setAppBadge?.(n); else navigator.clearAppBadge?.(); } catch (e) { console.error("setBadge: no se pudo actualizar el globo de la app", e?.name); }
};

export function useAlertCount() {
  const [count, setCount] = useState(0);
  const load = useCallback(() => api.get("/alerts/count").then((r) => { setCount(r.data.unread); setBadge(r.data.unread); }).catch((e) => console.error("useAlertCount: no se pudo leer el conteo de alertas", e?.response?.status ?? e?.name)), []);
  useEffect(() => {
    load();
    const t = setInterval(load, 60000);
    window.addEventListener("alerts:changed", load);
    return () => { clearInterval(t); window.removeEventListener("alerts:changed", load); };
  }, [load]);
  return count;
}
